<mat-chip-listbox [multiple]="true" class="no-scrollbar">
  @for (option of $puebloOptions(); track option.pueblo.resourceName) {
    <div class="pueblo-chip-container">
      <mat-chip-option
        class="pueblo-chip"
        (selectionChange)="handlePuebloSelectionChange($event, option)"
        [selected]="option.selected"
      >
        @if (option.pueblo.imageUrl) {
          <img matChipAvatar [src]="option.pueblo.imageUrl" />
        } @else {
          <mat-icon matChipAvatar>holiday_village</mat-icon>
        }
        <div class="pueblo-chip-label">
          <span class="pueblo-chip-name">{{ option.pueblo.name }}</span>
          <span class="label-xsmall"
            >{{ countLabel(option.pueblo.members.length, "member") }}
          </span>
        </div>

        <mat-form-field
          *vIf="option.selected; animations: [VisibilityAnimation.FADE]"
          appearance="outline"
          subscriptSizing="dynamic"
          class="notify-pueblo-select"
          matChipTrailingIcon
        >
          <mat-select
            #notifyPuebloSelect
            [value]="option.notify"
            (selectionChange)="handlePuebloNotificationChange($event, option)"
          >
            <mat-option
              class="label-small"
              [value]="NotifyPuebloOption.EVERYONE"
            >
              Everyone
            </mat-option>
            <mat-option
              class="label-small"
              [value]="NotifyPuebloOption.INTERESTS"
              [disabled]="$notifyInterestDisabled()"
            >
              <div>Based on interests</div>
              @if ($notifyInterestDisabled()) {
                <div class="label-xsmall">Tag interests to enable</div>
              }
            </mat-option>
          </mat-select>
          <mat-icon matIconPrefix class="size-16 on-primary-text">
            notifications
          </mat-icon>
        </mat-form-field>
      </mat-chip-option>
    </div>
  }
</mat-chip-listbox>
